import { logWrapper } from '../../utils';

export default {
  validationService: [
    'runtimeConstant',
    function (runtimeConstant) {
      function validateCPF(cpf) {
        if (!cpf) return false;

        cpf = cpf.replace(/[^\d]+/g, '');

        var soma = 0;
        var resto;

        if (
          cpf === '00000000000' ||
          cpf === '11111111111' ||
          cpf === '22222222222' ||
          cpf === '33333333333' ||
          cpf === '44444444444' ||
          cpf === '55555555555' ||
          cpf === '66666666666' ||
          cpf === '77777777777' ||
          cpf === '88888888888' ||
          cpf === '99999999999'
        ) {
          return false;
        }

        for (var i = 1; i <= 9; i++) {
          soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
        }
        resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        if (resto !== parseInt(cpf.substring(9, 10))) return false;
        soma = 0;

        for (i = 1; i <= 10; i++) {
          soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
        }

        resto = (soma * 10) % 11;
        if (resto === 10 || resto === 11) resto = 0;
        if (resto !== parseInt(cpf.substring(10, 11))) return false;

        return true;
      }

      function validateFalsePositive(cnpj) {
        cnpj = cnpj.replace(/[^\d]+/g, '');

        if (cnpj === '' || cnpj.length !== 14) return false;

        if (
          cnpj === '00000000000000' ||
          cnpj === '11111111111111' ||
          cnpj === '22222222222222' ||
          cnpj === '33333333333333' ||
          cnpj === '44444444444444' ||
          cnpj === '55555555555555' ||
          cnpj === '66666666666666' ||
          cnpj === '77777777777777' ||
          cnpj === '88888888888888' ||
          cnpj === '99999999999999'
        ) {
          return false;
        }

        return true;
      }

      function validateDVp2(cnpj, tamanho, digitos) {
        tamanho = tamanho + 1;
        var numeros = cnpj.substring(0, tamanho);
        var soma = 0;
        var pos = tamanho - 7;

        for (var i = tamanho; i >= 1; i--) {
          soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
          if (pos < 2) pos = 9;
        }
        var resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado !== parseInt(digitos.charAt(1))) return false;

        return true;
      }

      function validateDV(cnpj) {
        var tamanho = cnpj.length - 2;
        var numeros = cnpj.substring(0, tamanho);
        var digitos = cnpj.substring(tamanho);
        var soma = 0;
        var pos = tamanho - 7;
        for (var i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2) pos = 9;
        }

        var resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
        if (resultado !== parseInt(digitos.charAt(0))) return false;
        return this.validateDVp2(cnpj, tamanho, digitos);
      }

      function validateCNPJ(cnpj) {
        if (!cnpj) return false;
        cnpj = cnpj.replace(/[^\d]+/g, '');
        var res = this.validateFalsePositive(cnpj);
        if (res === false) return false;
        return this.validateDV(cnpj);
      }

      function run() {
        try {
          var validationServiceFactory = {
            validateCPF: logWrapper(
              validateCPF,
              runtimeConstant.isDebugServicesInternals
            ),
            validateFalsePositive: logWrapper(
              validateFalsePositive,
              runtimeConstant.isDebugServicesInternals
            ),
            validateDVp2: logWrapper(
              validateDVp2,
              runtimeConstant.isDebugServicesInternals
            ),
            validateDV: logWrapper(
              validateDV,
              runtimeConstant.isDebugServicesInternals
            ),
            validateCNPJ: logWrapper(
              validateCNPJ,
              runtimeConstant.isDebugServicesInternals
            ),
          };

          return validationServiceFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
